import { Anchor, Avatar, Button, Modal, Stack, Text, Title } from '@mantine/core';
import { useApp } from '../../context/AppContext';
import { primaryColor } from '../../constants/theme';

export const AccountSuspendedModal = () => {
  const { accountSuspended, logout, profile } = useApp();

  return (
    <Modal
      opened={accountSuspended}
      onClose={() => {}}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
    >
      <Stack gap="md" p="sm" align="center">
        <Avatar
          src={profile?.profilePicture}
          size={80}
          radius={80}
          style={{ filter: 'grayscale(100%)' }}
        />
        <Title order={3} fw="normal" ta="center">
          Account Suspended
        </Title>
        <Text ta="center">
          Your account has been suspended. Please contact support for assistance.
        </Text>
        <Text ta="center">
          <Anchor href="mailto:support@circlebe.com">
            support@circlebe.com
          </Anchor>
        </Text>
        <Button color={primaryColor} onClick={logout} fullWidth>
          Log out
        </Button>
      </Stack>
    </Modal>
  );
};
